<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records">
            <div class="row">
                <div class="col-12 mb-4 pl-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-5">
                                <div class="row no-gutters justify-content-center">
                                    <div class="col-md-5 text-center check-consultion">
                                        <figure><img src="../../../../static/website/images/appointment-calendar.svg" alt="" /></figure>
                                        <p>
                                            Congratulations your next Consultation with Dr. <br />
                                            Sabnam Kar is at 04:00 PM Monday. Join the
                                        </p>
                                        <h6>online meeting here: <a href="https://www.client.ginihealth.com/consult">https://www.client.ginihealth.com/consult</a></h6>
                                        <div class="text-center chek-bg border-radius-5 mt-3 mb-4">
                                            <p>Please Fill the intake Questionnaire Form to get dedicated assistance in your Health Journey</p>
                                            <router-link to="/intake-questionaries" class="btn btn-blue Assessment">Click Here to Take Assessment</router-link>
                                        </div>
                                        <router-link to="/" class="text-center back">Back to Consultations</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "check-consultation",
        data() {
            return {};
        },
        created(){
           this.pageName('Intake Questionnaire')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/consultant/check-consultaion.vue